const SECRET_REGEX = /nothirdparty=f28cc33464bcedc1cb08280e7d7fcb8d1aad6fb41e806a62cb4080fe329e8259/

const isLocalhost = () => {
  return process.env.NODE_ENV === 'development'
}

const redirectTo = (url) => {
  if (process.env.NODE_ENV === 'development') {
    return
  } else {
    window.location.href = url
  }
}

const openNewTab = (url) => {
  if (process.env.NODE_ENV === 'development') {
    return ''
  } else {
    window.open(url)
  }
}

const _hasDisabledThirdPartyScriptCookie = () => {
  return SECRET_REGEX.test(document.cookie)
}

const _hasDisabledThirdPartyScriptQueryParam = () => {
  return SECRET_REGEX.test(window.location.href)
}

/**
 * Escape hatch used by automated tests and audits to keep third party
 * scripts (GTM included) out of the page.
 */
const isDisabledThirdPartyScript = () => {
  return _hasDisabledThirdPartyScriptCookie() || _hasDisabledThirdPartyScriptQueryParam()
}

export {
  isDisabledThirdPartyScript,
  isLocalhost,
  openNewTab,
  redirectTo
}
